exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".float-action-menu{position:fixed;bottom:0;right:0;z-index:1;margin-bottom:calc(calc(49pt + env(safe-area-inset-bottom, 0)) + 10px);margin-right:10px}.float-action-menu .float-action-button{display:flex;align-items:center;justify-content:center;width:56px;height:56px;position:relative;border-radius:50%;box-shadow:0px 5px 11px -2px #333,0px 4px 12px -7px #333;background-color:#54c2b6;color:#fff;cursor:pointer}.float-action-menu .float-action-button:hover,.float-action-menu .float-action-button:focus,.float-action-menu .float-action-button:active{-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:#26a995}.float-action-menu .float-action-button:active{transform:translateY(1px);box-shadow:none}.float-action-menu [tooltip]:before{content:attr(tooltip);background:#333;padding:5px 7px;margin-right:10px;border-radius:2px;color:#fff;white-space:nowrap;position:absolute;bottom:20%;right:100%;visibility:hidden;opacity:0;transition:.3s}.float-action-menu [tooltip]:hover:before{visibility:visible;opacity:1;z-index:10}", ""]);

// Exports
exports.locals = {
	"colorTeal": "#54c2b6",
	"colorTealRedChannel": "84",
	"colorTealGreenChannel": "194",
	"colorTealBlueChannel": "182",
	"colorTealDark": "#26a995",
	"colorTeal50": "rgba(84,194,182,.5)",
	"colorTealScreened": "#54c2b6",
	"colorWhiteOff": "#f2f2f2",
	"colorWhite": "#fff",
	"colorWhiteTrans": "rgba(255,255,255,0)",
	"colorWhite50": "rgba(255,255,255,.5)",
	"colorBlack": "#333",
	"colorGrayDark": "#4f4f4f",
	"colorGray": "#828282",
	"colorGrayLight": "#e0e0e0",
	"colorBlue": "#049fda",
	"colorBlueScreened": "#049fda",
	"colorMagenta": "#ea3b7d",
	"colorMagentaScreened": "#ea3b7d",
	"colorYellow": "#fed504",
	"colorYellowDark": "#d8b129",
	"colorYellowScreened": "#fed504",
	"colorUi1": "rgba(4,159,218,.3)",
	"colorUi2": "rgba(84,194,182,.3)",
	"colorUi3": "rgba(234,59,125,.3)",
	"colorUi4": "rgba(254,213,4,.3)",
	"colorUi5": "rgba(31,79,228,.3)",
	"colorUi6": "rgba(177,208,21,.3)",
	"colorUi7": "rgba(228,34,255,.3)",
	"colorUi8": "rgba(255,157,39,.3)",
	"colorUi9": "rgba(66,32,208,.3)",
	"colorUi10": "rgba(26,255,198,.3)",
	"colorUi11": "rgba(205,38,26,.3)",
	"colorUi12": "rgba(247,184,50,.3)",
	"colorUi13": "rgba(146,79,207,.3)",
	"colorUi14": "rgba(98,205,36,.3)",
	"colorUi15": "rgba(255,24,9,.3)",
	"colorUi16": "rgba(207,111,79,.3)",
	"colorGreen": "#0acf97"
};